import React from 'react';
import { OrderDetailsDTO } from '../../types/order';

interface NotesCardProps {
  order: OrderDetailsDTO;
}

const NotesCard: React.FC<NotesCardProps> = ({ order }) => {
  const hasNotes = order.notes?.customerNote || order.notes?.internalNote;
  
  if (!hasNotes) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Notes & Requirements</h3>
        <div className="text-center py-8 text-gray-500">
          <p>No notes available</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Notes & Requirements</h3>
      <div className="space-y-4">
        {order.notes?.customerNote && (
          <div>
            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 block">
              Customer Notes
            </label>
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{order.notes.customerNote}</p>
          </div>
        )}
        
        {order.notes?.internalNote && (
          <div>
            <label className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2 block">
              Internal Notes
            </label>
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{order.notes.internalNote}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotesCard;

